export function insertElementBefore(newNode, parentNode) {
	parentNode.appendChild(newNode);
	parentNode.insertBefore(newNode, parentNode.childNodes[0]);
}

export function insertElementAfter(newNode, targetElement) {
	// target is what you want it to go after. Look for this elements parent.
	var parent = targetElement.parentNode;

	// if the parents lastchild is the targetElement...
	if (parent.lastChild === targetElement) {
		// add the newNode after the target element.
		parent.appendChild(newNode);
	} else {
		// else the target has siblings, insert the new element between the target and it's next sibling.
		parent.insertBefore(newNode, targetElement.nextSibling);
	}
}

export function debounce(func, wait, immediate) {
	let timeout;
	return function() {
		const context = this,
			args = arguments;
		const later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

// Toggle an attribute's aria values
export function toggleAttribute(el, attribute) {
	const currentAttribute = el.getAttribute(attribute);

	currentAttribute == 'false'
		? el.setAttribute(attribute, 'true')
		: el.setAttribute(attribute, 'false');
}

// Toggle an element's class
export function toggleClass(el, classname) {
	el.classList.contains(classname)
		? el.classList.remove(classname)
		: el.classList.add(classname);
}

// Reframe iframes at a fixed ratio
// via:  https://github.com/dollarshaveclub/reframe.js
export function reframe(target, cName) {
	let frames = typeof target === 'string' ? document.querySelectorAll(target) : target;
	const c = cName || 'js-reframe';
	if (!('length' in frames)) frames = [frames];
	for (let i = 0; i < frames.length; i += 1) {
		const frame = frames[i];
		// makes sure reframe is not run more than 1x ✔️
		const hasClass = frame.className.split(' ').indexOf(c) !== -1;
		if (hasClass) return;

		// get height width attributes
		const hAttr = frame.getAttribute('height');
		const wAttr = frame.getAttribute('width');
		// if has percentage width assume the iframe is responsive
		if (wAttr.indexOf('%') > -1 || frame.style.width.indexOf('%') > -1) return;
		const h = hAttr || frame.offsetHeight;
		const w = wAttr || frame.offsetWidth;

		// general targeted <element> sizes
		const padding = h / w * 100;

		// created element <wrapper> of general reframed item
		// => set necessary styles of created element <wrapper>
		const div = document.createElement('div');
		div.className = c;
		const divStyles = div.style;
		divStyles.position = 'relative';
		divStyles.width = '100%';
		divStyles.paddingTop = `${padding}%`;

		// set necessary styles of targeted <element>
		const frameStyle = frame.style;
		frameStyle.position = 'absolute';
		frameStyle.width = '100%';
		frameStyle.height = '100%';
		frameStyle.left = '0';
		frameStyle.top = '0';

		// reframe targeted <element>
		frame.parentNode.insertBefore(div, frame);
		frame.parentNode.removeChild(frame);
		div.appendChild(frame);
	}
}
